/**
 * paginationDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

export function paginationDirective() {
    return {
        transclude: true,
        // language=HTML
        template: `
            <nav class="pagination">
                <div class="app-pagination-meta" ng-if="paginator && !paginator.loading">
                    <span>
                        {{ paginator.perPage }} per page
                    </span>
                    
                    <span ng-if="paginator.total > 0">
                        &bull;
                        
                        {{ paginator.total }} total
                    </span>
                </div>

                <!--
                <div class="app-pagination-per-page">
                    <label for="item-per-page">Items per page:</label>

                    <app-input-select dense
                                      id="item-per-page"
                                      value="paginator.perPage">
                        <md-option ng-value="15">15</md-option>
                        <md-option ng-value="30">30</md-option>
                        <md-option ng-value="60">60</md-option>
                    </app-input-select>
                </div>
                -->

                <div class="app-pagination-controls">
                    <md-button ng-click="previousPage()"
                               ng-disabled="ui.current == 1 || ui.disabled"
                               aria-label="Go to the previous page"
                               title="Go to the previous page">
                        <md-icon>chevron_left</md-icon>
                    </md-button>

                    <md-select class="app-pagination-current"
                               ng-class="{ 'app-pagination-current-fetching': paginator.fetching }"
                               ng-disabled="ui.disabled || ui.pageCount <= 1"
                               ng-model="ui.current"
                               md-container-class="app-pagination-current-select-container"
                               md-selected-text="ui.current + ' / '  + ui.pageCount">
                        <md-option ng-repeat="pageNumber in range(ui.pageCount) track by $index"
                                   ng-value="pageNumber">
                            {{ pageNumber }}
                        </md-option>
                    </md-select>

                    <md-button ng-click="nextPage()"
                               ng-disabled="ui.disabled || ui.current == ui.pageCount || !ui.pageCount"
                               aria-label="Go to the next page"
                               title="Go to the next page">
                        <md-icon>chevron_right</md-icon>
                    </md-button>
                </div>
            </nav>
        `,
        scope: {
            current: '=current',
            onChange: '&?change',
            pageCount: '=pageCount',
            disabled: '=?ngDisabled',
            paginator: '=?paginator',
        },
        link: function(scope) {
            scope.goToPage = goToPage;
            scope.nextPage = nextPage;
            scope.previousPage = previousPage;
            scope.range = n =>
                new Array(n).fill(undefined).map((value, index) => {
                    return index + 1;
                });

            const ui = (scope.ui = {
                set current(page) {
                    if (page && this.current && parseInt(page) !== parseInt(this.current)) {
                        goToPage(page);
                    }
                },

                get current() {
                    return scope.paginator ? scope.paginator.currentPage : scope.current;
                },

                get pageCount() {
                    return scope.paginator ? scope.paginator.totalPages : scope.pageCount;
                },

                get disabled() {
                    return scope.disabled || (scope.paginator ? scope.paginator.loading : false);
                },
            });

            function goToPage(pageNumber) {
                if (angular.isFunction(scope.onChange)) {
                    scope.onChange({
                        newPage: pageNumber,
                    });
                }
            }

            function nextPage() {
                scope.goToPage(Math.min(ui.pageCount, ui.current + 1));
            }

            function previousPage() {
                scope.goToPage(Math.max(1, ui.current - 1));
            }
        },
    };
}
